import { useAuthStore } from '@/stores/auth.store'
import { useRouter, useRoute } from 'vue-router'

export function useAuth() {
  const authStore = useAuthStore()
  const router = useRouter()
  const route = useRoute()

  const login = async (email: string, password: string) => {
    const success = await authStore.login(email, password)
    if (success && authStore.isAuthenticated) {
      const redirect = (route.query.redirect as string) || '/dashboard'
      router.push(redirect)
    }
  }

  const portalLogin = async (
    username: string,
    password: string,
    companyDomain?: string,
    consents?: { kvkkAccepted?: boolean; usageAccepted?: boolean },
  ) => {
    const success = await authStore.portalLogin(username, password, companyDomain, consents)
    if (success && authStore.isAuthenticated) {
      const raw = (route.query.redirect as string) || '/portal'
      const pathOnly = raw.split('?')[0].trim() || '/portal'
      const target =
        pathOnly.startsWith('/portal') && pathOnly !== '/login'
          ? raw
          : '/portal'
      router.push(target)
    }
  }

  const logout = async () => {
    await authStore.logout()
  }

  const hasRole = (role: string | string[]) => {
    const roles = Array.isArray(role) ? role : [role]
    return authStore.user ? roles.includes(authStore.user.role) : false
  }

  const hasPermission = (permission: string) => {
    return authStore.isAuthenticated
  }

  return {
    user: authStore.user,
    isAuthenticated: authStore.isAuthenticated,
    isAdmin: authStore.isAdmin,
    isHR: authStore.isHR,
    isManager: authStore.isManager,
    isEmployee: authStore.isEmployee,
    fullName: authStore.fullName,
    isLoading: authStore.isLoading,
    error: authStore.error,
    login,
    portalLogin,
    logout,
    hasRole,
    hasPermission
  }
}
